module.exports = __webpack_public_path__ + "static/013_Gippsland_a-200dc40fa70f7f4605e84fb3e4cff02b.jpg";